import { Component, OnInit, Input, isDevMode, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CyclistService } from '../../../services/cyclist.service';
import { BikeService } from '../../../services/bike.service';
import { ServiceRequestService } from '../../../services/servicerequest.service';
import { Project529Service } from '../../../services/project529.service';
import { HelpersService } from '../../../services/helpers.service';
import { ChecklistService } from "../../../services/checklist.service";
import { AppConfig } from "../../../app.config";
import { MessageService } from 'primeng/api';
import { MenuItem } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { JoyrideService } from 'ngx-joyride';
import { JobcardService } from '../../../services/jobcard.service';
import { PosIntegrationService } from '../../../services/pos-integration.service';
import { ThirdPartyService } from '../../../services/thirdparty.service';
import { ChangeDetectorRef } from '@angular/core';
import { ReceiptTemplateService } from 'src/app/components/portal/bikeshop/receipt-template-designer/services/receipt-template.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-update-jobcard',
  templateUrl: './update-jobcard.component.html',
  styleUrls: ['./update-jobcard.component.scss'],
  providers: [MessageService]
})
export class UpdateJobcardComponent implements OnInit {

  @Input() jobcard;
  @Input() summaryData;
  @Input() jobcardID;
  @Input() partnerID;
  @Input() jobApproved;
  @Input() goToMessaging;
  @Input() defaultTab;

  public cyclist: any = {};
  public dataLoaded: boolean = false;
  public activeItem: MenuItem;
  public selectedTab: number;
  public bike: any = {};
  public bikeGear: any = [];
  public busyLinkingToNewUser: boolean = false;
  public newSearchUser: any = {};
  public partner: any = {};
  public initialLoad: boolean = true;

  public jobCardItems: MenuItem[] = [];
  public hasFittingInfoFlag: boolean = true;
  public showMenu: boolean = true;

  constructor(
    public appConfig: AppConfig,
    public cyclistService: CyclistService,
    public bikeService: BikeService,
    public messageService: MessageService,
    public modal: NgbActiveModal,
    private translate: TranslateService,
    private helpersService: HelpersService,
    private joyrideService: JoyrideService,
    private checklistService: ChecklistService,
    public jobcardService: JobcardService,
    public posIntegrationService: PosIntegrationService,
    public thirdPartyService: ThirdPartyService,
    private serviceRequest: ServiceRequestService,
    private project529Service: Project529Service,
    private cdr: ChangeDetectorRef,
    private receiptTemplateService: ReceiptTemplateService,
  ) {
    this.partner = this.helpersService.getPartnerData();

    this.jobCardItems = [
      { label: this.translate.instant('bikeshop.modal.update_job_card.tab.jobcard'), command: () => { this.selectedTab = 0 } },
      { label: this.translate.instant('bikeshop.modal.update_job_card.tab.quote'), command: () => { this.selectedTab = 1 } },
      { label: this.translate.instant('bikeshop.modal.update_job_card.tab.bike'), command: () => { this.selectedTab = 2 } },
      { label: this.translate.instant('bikeshop.modal.update_job_card.tab.messaging'), command: () => { this.selectedTab = 3 } },
      { label: this.translate.instant('bikeshop.modal.update_job_card.tab.attachments'), command: () => { this.selectedTab = 4 } }
    ];

    this.activeItem = this.jobCardItems[0];
    this.selectedTab = 0;

  }

  hasChecklistItems() {
    this.checklistService.hasChecklistItems(this.helpersService.getPartnerId()).subscribe(res => {
      this.helpersService.setChecklistCount(res.checklistCount);
      this.jobCardItems.push({ label: this.translate.instant('bikeshop.modal.update_job_card.tab.checklist'), command: () => { this.selectedTab = 6 } });
    }, err => {
      this.helpersService.setChecklistCount(0);
    })
  }

  hasFittingInfo() {
    this.cyclistService.getFittingInfo(this.jobcard.CyclistID).subscribe(fittingInfo => {
      if ((
        fittingInfo.areasOfDiscomfort === null || fittingInfo.areasOfDiscomfort === ""
        || fittingInfo.injuryHistory === null || fittingInfo.injuryHistory === ""
        || fittingInfo.ridingGoals === null || fittingInfo.ridingGoals === ""
        || fittingInfo.yearsRiding === null || fittingInfo.yearsRiding === ""))
        this.jobCardItems.splice(this.jobCardItems.findIndex(x => x.label === this.translate.instant('bikeshop.modal.update_job_card.tab.fitting_info')), 1);
      this.hasFittingInfoFlag = false;
      this.showMenu = false;
      this.cdr.detectChanges();
      this.showMenu = true;
    });
   
  }

  public getJobcardItems() { return this.jobCardItems; }



  ngOnInit() {
    if (this.jobcard && this.jobcard.ID) {
      this.setupJobCard();
    } else {
      this.getJobCard();
    }
  }

  getJobCard() {
    this.serviceRequest.getServiceRequestData(this.jobcardID).subscribe((jobcard) => {
      this.jobcard = jobcard;
      this.setupJobCard();
      this.getProject529Status();
      setTimeout(() => {
        this.initialLoad = false;
      }, 500);
    });
  }

  getProject529Status() {
    if (this.partner.PartnerType == 1 && this.partner.Project529Enabled) {
      this.project529Service.getServiceProject529Status(this.jobcardID).subscribe((status) => {
        this.jobcard.project529 = {
          ...status
        };
        this.cdr.detectChanges();
      });
    }
  }

  setupJobCard() {
    this.selectedTab = this.defaultTab && this.defaultTab === "JOBCARD" ? 0 : this.defaultTab && this.defaultTab === "QUOTE" ? 1 : 0;
    this.activeItem = this.jobCardItems[this.selectedTab];

    if (this.jobcard && this.helpersService.getChecklistCount() && this.helpersService.getChecklistCount() > 0) {
      this.jobCardItems.push({ label: this.translate.instant('bikeshop.modal.update_job_card.tab.checklist'), command: () => { this.selectedTab = 6 } });
    } else if (this.helpersService.getChecklistCount() === null) {
      this.hasChecklistItems();
    }

    if (this.jobcard && !this.jobcard.IsFitting) {
      if (this.partner.OffersCollections || this.partner.OffersDropOffs) {
        this.jobCardItems.push({ label: this.translate.instant('bikeshop.modal.update_job_card.tab.collections'), command: () => { this.selectedTab = 5 } });
      }
      this.jobCardItems.push({ label: "Linked Jobs", command: () => { this.selectedTab = 7 } });
    } else if (this.partner.PartnerType === 1) {
      if (this.hasFittingInfoFlag)
        this.jobCardItems.push({ label: this.translate.instant('bikeshop.modal.update_job_card.tab.fitting_info'), command: () => { this.selectedTab = 8 } });
      this.hasFittingInfo();
    }

    if (this.jobcard && this.jobcard.CustomQuestions && this.jobcard.CustomQuestions.length > 0) {
      this.jobCardItems.push({ label: this.translate.instant('bikeshop.modal.update_job_card.tab.custom_questions'), command: () => { this.selectedTab = 9 } });
    }


    this.jobCardItems.push({ label: this.translate.instant('bikeshop.modal.update_job_card.tab.waivers'), command: () => { this.selectedTab = 10 } });


    this.getCyclist();
    this.getBike();
    this.getBikeGear();
    if (this.goToMessaging) {
      this.activeItem = this.jobCardItems[3];
      this.selectedTab = 3;
    }

    //if (this.helpersService.showTour("JobCard")) {
    //  setTimeout(() => {
    //    this.joyrideService.startTour(
    //      {
    //        steps: ['jobcardStepOne', 'jobcardStepTwo'],
    //        themeColor: '#151A2A'
    //      }
    //    );
    //  }, 500)
    //}



    this.checkIfJobcardMustDisconnectFromPOS();
  }

  checkIfJobcardMustDisconnectFromPOS() {
    this.jobcardService.checkIfJobcardMustDisconnectFromPOS(this.jobcard.ID).subscribe(x => {

    });
  }

  tourDone() {
    this.helpersService.tourComplete("JobCard");
  }

  setActiveItem(event) {

  }

  cancelRelink() {
    this.cyclistService.getCyclistById(this.cyclist.ID).subscribe(cyclist => {
      this.cyclist = cyclist;
      this.busyLinkingToNewUser = false;
    });
  }

  relinked(item) {
    this.cyclistService.getCyclistById(item.CyclistID).subscribe(cyclist => {
      this.cyclist = cyclist;
      this.jobcard = item;
      this.busyLinkingToNewUser = false;
    });
  }

  linkToNewUser(item) {
    this.newSearchUser = item;
    this.busyLinkingToNewUser = true;
  }

  getCyclist() {

    // if (this.jobcard.PhoneNumber || this.jobcard.Email) {
    //   this.cyclist = { ID: this.jobcard.CyclistID, PhoneNumber: this.jobcard.PhoneNumber, Email: this.jobcard.Email, Name: this.jobcard.Name, Surname: this.jobcard.Surname, DateOfBirth: this.jobcard.DateOfBirth };
    //   this.dataLoaded = true;
    // } else {
    //   this.cyclistService.getCyclistById(this.jobcard.CyclistID).subscribe(cyclist => {
    //     this.cyclist = cyclist;
    //     this.dataLoaded = true;
    //   });
    // }
    this.cyclist = { ID: this.jobcard.CyclistID, PhoneNumber: this.jobcard.PhoneNumber, Email: this.jobcard.Email, Name: this.jobcard.Name, Surname: this.jobcard.Surname, DateOfBirth: this.jobcard.DateOfBirth };
    this.dataLoaded = true;

  }

  getBike() {
    this.bikeService.getBike(this.jobcard.BikeID).subscribe(bike => {
      this.bike = bike;
    });
  }

  getBikeGear() {
    //TODO there is no units for Month, currently also a hack to figure out if KM or HRS is being used.
    this.bikeService.getActiveGear(this.jobcard.BikeID).subscribe(bikeGear => {
      this.bikeGear = bikeGear;
    });
  }

  updateJobCard(jobcard) {
    this.jobcard = jobcard;
    this.getProject529Status();
  }

  completeCheckList(event) {

  }

  printJobCard() {
  
            // No active receipt template — use the existing print path.
            const url = this.helpersService.getPrinterType() === 'A4'
              ? `/print/${this.jobcard.ID}`
              : `/print-till-slip/${this.jobcard.ID}`;
            const win = window.open(url, '_blank');
            if (win) win.focus();

  }


}
